import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import themeLight from "./theme/themeLight";
import themeDark from "./theme/themeDark";
import DesktopLandingpage from "./components/Desktop/DesktopLandingpage";
import { Router } from "@reach/router";
import useMediaQueryUI from "@material-ui/core/useMediaQuery";
import "./theme/chartsTheme.css";
import { ApolloProvider } from "@apollo/client";
import { client } from "./GraphQL/setup";
import { useRecoilValue } from "recoil";
import { themeState } from "./lib/recoil";

import Routes from "./routes/routes";
import createPalette from "@material-ui/core/styles/createPalette";
import Privacy from "./components/Profile/Privacy";
import Impressum from "./components/Profile/Impressum";

function App() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1025px)",
  });
  const isMobileDevice = useMediaQuery({
    query: "(max-device-width: 1024px )",
  });

  const prefersDarkMode = useMediaQueryUI("(prefers-color-scheme: dark)");

  const themeSelection = useRecoilValue(themeState);
  const [theme, setTheme] = React.useState(themeLight);

  useEffect(() => {
    if (themeSelection === "light") {
      setTheme((prevState) => ({
        ...prevState,
        palette: createPalette({
          type: "light",
          primary: {
            main: "#0e4da4",
          },
        }),
      }));
    } else if (themeSelection === "dark") {
      setTheme((prevState) => ({
        ...prevState,
        palette: createPalette({
          type: "dark",
          primary: {
            main: "#6999dd",
          },
        }),
      }));
    } else {
      setTheme(prefersDarkMode ? themeDark : themeLight);
    }
  }, [themeSelection, prefersDarkMode]);

  return (
    <div>
      {isDesktopOrLaptop && (
        <ThemeProvider theme={themeLight}>
          <>
            <Router>
              <DesktopLandingpage path="/" default />
              <Privacy isDesktop path="/privacy" />
              <Impressum isDesktop path="/impressum" />
            </Router>
          </>
        </ThemeProvider>
      )}
      {isMobileDevice && (
        <ThemeProvider theme={theme}>
          <ApolloProvider client={client}>
            <CssBaseline />
            <Routes />
          </ApolloProvider>
        </ThemeProvider>
      )}
    </div>
  );
}

export default App;
